import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	listItemData: {
		opacity: "0.5",
		fontSize: "14px"
	},
	clockIcon: {
		width: "16px",
		height: "16px",
		color: themeColors.colors.system.gray[700],
		opacity: "0.5"
	},
	chip: {
		color: themeColors.colors.system.gray[700],
		fontSize: 14,
		padding: "4px 16px"
	}
}))

export default useStyles
